<template>
  <div class="container-fluid">
    <div class="m-2">
      <div class="alert alert-primary text-center">
        <div class="h4">
          <linkto :link="'/'"/>
          Email kiküldések
        </div>
        <div class="small">
          Ügyfél levelek (számla, rendelés értesítő) naponta, küldő címenként.
          Napi keret címenként: {{ limit }} levél. A crm@ belső riportjai nincsenek benne.
        </div>
      </div>
      <div v-if="showSkipped" class="alert alert-warning text-center small mb-0">
        <span v-if="testMode"><b>Tesztüzem</b> (ORDER_NOTIFY_ONLY_USZAM): rendelés értesítő csak a megadott ügyfeleknek megy.</span>
        A „Tesztüzem miatt nem ment” oszlop azokat az értesítőket mutatja, amelyek éles üzemben kimentek volna.
        Az időszakban éles üzemben összesen <b>{{ totalWouldBe }}</b> levél ment volna ({{ total }} kiment + {{ totalSkipped }} visszatartva).
      </div>
    </div>

    <div class="row d-flex justify-content-center m-2">
      <div class="col-6 col-md-4 col-lg-2 text-center">
        <span class="h6">Kezdő nap</span>
        <input type="date" class="form-control text-center" v-model="from">
      </div>
      <div class="col-6 col-md-4 col-lg-2 text-center">
        <span class="h6">Utolsó nap</span>
        <input type="date" class="form-control text-center" v-model="to">
      </div>
      <div class="col-12 col-md-4 col-lg-2 text-center d-flex align-items-end mt-2 mt-md-0">
        <button class="btn btn-primary btn-block" @click.prevent="load">Frissít</button>
      </div>
    </div>

    <div v-if="today" class="row d-flex justify-content-center m-2">
      <div v-for="a in accounts" :key="a" class="col-12 col-md-4 col-lg-3 mb-2">
        <div class="card text-center">
          <div class="card-body p-2">
            <div class="small text-muted">{{ a }} – ma</div>
            <div class="h4 mb-1" :class="{ 'text-danger': (today.counts[a] || 0) >= limit }">
              {{ today.counts[a] || 0 }} / {{ limit }}
            </div>
            <div class="progress" style="height: 6px;">
              <div class="progress-bar" :class="barClass(today.counts[a] || 0)" :style="{ width: pct(today.counts[a] || 0) + '%' }"></div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="showSkipped" class="col-12 col-md-4 col-lg-3 mb-2">
        <div class="card text-center border-warning">
          <div class="card-body p-2">
            <div class="small text-muted">Éles üzemben ma (összes cím)</div>
            <div class="h4 mb-1" :class="{ 'text-danger': (today.wouldBe || 0) >= limit * accounts.length }">
              {{ today.wouldBe || 0 }} / {{ limit * accounts.length }}
            </div>
            <div class="small text-muted">ebből tesztüzem miatt nem ment: {{ today.skipped || 0 }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table table-striped table-sm text-center">
        <thead>
          <tr>
            <th scope="col" class="text-left">Nap</th>
            <th v-for="a in accounts" :key="a" scope="col">{{ a }}</th>
            <th scope="col">Napi összesen</th>
            <th v-if="showSkipped" scope="col" class="text-warning">Tesztüzem miatt nem ment</th>
            <th v-if="showSkipped" scope="col">Éles üzemben</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="days.length == 0">
            <td :colspan="accounts.length + (showSkipped ? 4 : 2)" class="text-muted">Ebben az időszakban nem ment ki levél.</td>
          </tr>
          <tr v-for="d in days" :key="d.datum">
            <td class="text-left text-nowrap">{{ d.datum }} <span class="text-muted small">{{ weekday(d.datum) }}</span></td>
            <td v-for="a in accounts" :key="a" :class="{ 'text-danger font-weight-bold': (d.counts[a] || 0) >= limit }">
              {{ d.counts[a] || 0 }}
            </td>
            <td class="font-weight-bold">{{ d.total }}</td>
            <td v-if="showSkipped" class="text-warning">{{ d.skipped || 0 }}</td>
            <td v-if="showSkipped" class="font-weight-bold" :class="{ 'text-danger': (d.wouldBe || 0) >= limit * accounts.length }">{{ d.wouldBe || 0 }}</td>
          </tr>
        </tbody>
        <tfoot v-if="days.length">
          <tr class="font-weight-bold">
            <td class="text-left">Időszak összesen</td>
            <td v-for="a in accounts" :key="a">{{ totals[a] || 0 }}</td>
            <td>{{ total }}</td>
            <td v-if="showSkipped" class="text-warning">{{ totalSkipped }}</td>
            <td v-if="showSkipped">{{ totalWouldBe }}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'email_stats',
  data () {
    return {
      from: this.$moment().subtract(29, 'days').format('YYYY-MM-DD'),
      to: this.$moment().format('YYYY-MM-DD'),
      limit: 250,
      accounts: [],
      days: [],
      totals: {},
      total: 0,
      testMode: false,
      totalSkipped: 0,
      totalWouldBe: 0
    }
  },
  computed: {
    // Tesztüzemben, vagy ha az időszakban volt visszatartott értesítő
    showSkipped () {
      return this.testMode || this.totalSkipped > 0
    },
    today () {
      let d = this.$moment().format('YYYY-MM-DD')
      if (this.accounts.length == 0) return null
      return this.days.find(x => x.datum == d) || { datum: d, counts: {}, total: 0, skipped: 0, wouldBe: 0 }
    }
  },
  mounted () {
    this.load()
  },
  methods: {
    load () {
      this.$Progress.start()
      this.req.post('/emails/daily', { from: this.from, to: this.to })
        .then(res => {
          Object.assign(this, {
            limit: res.data.limit,
            accounts: res.data.accounts,
            days: res.data.days,
            totals: res.data.totals,
            total: res.data.total,
            testMode: !!res.data.testMode,
            totalSkipped: res.data.totalSkipped || 0,
            totalWouldBe: res.data.totalWouldBe || res.data.total
          })
          this.$Progress.finish()
        })
        .catch(err => {
          console.error(err)
          this.$Progress.fail()
          toastr.error((err.response && err.response.data && err.response.data.text) || 'Hiba a lekérés közben')
        })
    },
    weekday (d) {
      return this.$moment(d).format('dddd')
    },
    pct (n) {
      return Math.min(100, Math.round(n / this.limit * 100))
    },
    barClass (n) {
      let p = n / this.limit
      return p >= 1 ? 'bg-danger' : p >= 0.8 ? 'bg-warning' : 'bg-success'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/emails/email_stats.vue